export default "__VITE_ASSET__JvwaJE77__"